<app-table
    [translatePrefix]="prefix"
    tableKey="calendarPlansWidget"
    [columns]="columns"
    [hideCheckboxes]="true"
    [showColumnVisiblity]="true"
    [gridData]="store.plansData()"
    [additionalFilter]="additionalFilter()"
    [defaultSorters]="[{ column: 'dateFrom', direction: 'DESC' }]"
    (detailCallback)="detailPlan($event)"
></app-table>
